import { Container } from 'pixi.js';
import { RaceEventTutorialLayout } from '../../../../layouts/raceEvent/RaceEventTutorialLayout';

export class RaceEventPopupHelpView extends Container {
  private readonly layout = new RaceEventTutorialLayout();

  constructor() {
    super();
    this.layout.root.props({ parent: this });
  }
}
